import {ThemeProvider} from "@mui/material";
import React from "react";
import {theme} from "./_fri/themes/theme";
import {Outlet} from "react-router-dom";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";



function App() {
    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="App">
                    <Outlet/>
                </div>
            </LocalizationProvider>
        </ThemeProvider>
    );
}

export default App;
